import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({ providedIn: 'root' })
export class ApplicationInsightsService {

  appInsights: ApplicationInsights;
  constructor() {
    const appInsightsKey = environment.appInsights;
    this.appInsights = new ApplicationInsights({
      config: { instrumentationKey: appInsightsKey, enableAutoRouteTracking: true }
    });
    this.appInsights.loadAppInsights();
  }

  logException(exception: Error, severityLevel?: number) {
    console.log('logE', exception);
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

 

}
